import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center">
        <div className="text-center px-4">
          <p className="text-8xl font-display font-bold text-primary-100">404</p>
          <h1 className="mt-4 text-2xl font-display font-bold text-slate-900">Səhifə tapılmadı</h1>
          <p className="mt-2 text-slate-500">Axtardığınız səhifə mövcud deyil.</p>
          <Link to="/" className="mt-8 inline-flex items-center px-6 py-3 bg-primary-600 text-white rounded-full font-semibold hover:bg-primary-700 transition-colors">
            Ana Səhifəyə Qayıt
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
